import React from 'react';
import clsx from 'clsx';
import { MessageDescriptor, useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { DeltaPill } from '../../../components/primitives/DeltaPill';
import { Panel } from '../../../components/primitives/Panel';
import { PlaySourceTile, PlaySourceTileKey } from '../../periodSections';
import { changePctOf, formatChangePct } from '../../streamingFormat';
import { playSourcesMessages as messages } from '../../playSourcesMessages';
import { periodSeriesColor } from '../../period/periodColors';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import shared from '../../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the period sections; each part uses its own slice of it */
import styles from '../../StreamingPeriod.module.scss';
/* eslint-enable css-modules/no-unused-class */

export const PLAY_SOURCE_TILE_LABELS: Record<PlaySourceTileKey, MessageDescriptor> = {
  listenersAndYou: messages.tileListenersAndYou,
  store: messages.tileStore,
  other: messages.tileOther,
};

/** The colour of a tile, also used by the month bars and the legend. */
export const PLAY_SOURCE_TILE_COLORS: Record<PlaySourceTileKey, string> = {
  listenersAndYou: periodSeriesColor(0),
  store: periodSeriesColor(1),
  other: periodSeriesColor(3),
};

interface PlaySourceTilesProps {
  tiles: readonly PlaySourceTile[];
}

/** The three group tiles of Play sources (design streaming-sections b1): the share and the streams. */
const PlaySourceTilesComponent: React.FC<PlaySourceTilesProps> = ({ tiles }) => {
  const intl = useIntl();
  return (
    <div className={clsx(styles.kpis, styles.kpisThree)} data-testid="streaming-playSources-tiles">
      {tiles.map((tile) => {
        const changePct = changePctOf(tile.streams, tile.previousStreams);
        const change = formatChangePct(intl, changePct);
        const label = intl.formatMessage(PLAY_SOURCE_TILE_LABELS[tile.key]);
        return (
          <Panel key={tile.key} className={shared.tile} role="group" aria-label={label}>
            <span className={shared.tileLabel}>
              <span className={styles.swatch} style={{ background: PLAY_SOURCE_TILE_COLORS[tile.key] }} /> {label}
            </span>
            <span className={shared.tileValue}>
              {intl.formatNumber(tile.share, { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 })}
            </span>
            <span className={shared.tileRow}>
              {change !== null && changePct !== null ? <DeltaPill value={changePct} label={change} /> : null}
              <span className={shared.faint}>
                {intl.formatMessage(messages.tileStreams, { count: intl.formatNumber(tile.streams) })}
              </span>
            </span>
          </Panel>
        );
      })}
    </div>
  );
};

export const PlaySourceTiles = TypedMemo(PlaySourceTilesComponent);
